module.exports = __webpack_public_path__ + "img/person-sledding.c4612965.svg";